import {
    Component, Emit, Mixins,
} from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import Props from './props';

interface VeeValidateObserverRef extends Vue {
    reset(): void;
    validate(): void;
}

/**
 * @name Validator
 */
@Component({
    components: {
        ValidationObserver,
    },
})
class YValidator extends Mixins(Props) {
    $refs!: {
        form: VeeValidateObserverRef
    }

    /**
     * ReValidate
     */
    validate() {
        this.$refs.form.validate();
    }

    /**
     * Submit Form
     *
     * @param {object} observer
     */
    @Emit()
    submit(observer: object) {}

    /**
     * Submit Form
     *
     * @param {object} observer
     */
    @Emit()
    reset(observer: object) {
        this.$refs.form.reset();
    }

    /**
     * Emit Validation Result
     *
     * @param {object} observer
     */
    @Emit()
    validation(observer: object) {}
}

export default YValidator;
